export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M-0.00177189 2.0213L17.9743 19.9974L19.9957 17.9761L2.01953 8.83559e-08L-0.00177189 2.0213Z" fill="#919191" />
      <path d="M17.9787 0.00213419L0.00257165 17.9783L2.02387 19.9996L20 2.02344L17.9787 0.00213419Z" fill="#919191" />
    </svg>
  )
}
